import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TaskSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TaskSVG;
